// src/components/icons/HeartIcon.js
import React from 'react';
import { AiOutlineHeart, AiFillHeart } from 'react-icons/ai';

const HeartIcon = ({ isSelected }) => {
  return isSelected ? (
    <AiFillHeart size={24} color="currentColor" />
  ) : (
    <AiOutlineHeart size={24} color="currentColor" />
  );
};

export default HeartIcon;